<template>
    <div style="height: 100vh; background-color: #f8f8f8;">
        <van-nav-bar :title="title" left-arrow @click-left="$router.back()" :fixed="false" placeholder
            safe-area-inset-top></van-nav-bar>
        <div style="padding: 70px 10px;">
            <div v-html="html"></div>
        </div>
    </div>
</template>

<script>
const titles = {
    1: {
        title: '技术服务合同',
        html: require('./html/tech_contracts2.html').default
    },
    2: {
        title: '金声玉亮系列会员服务协议',
        html: require('./html/MembershipServiceAgreement.html').default,
    },
    3: {
        title: '金声玉亮隐私政策',
        html: require('./html/PrivacyPolicy.html').default
    }
};
export default {
    name: 'ProtocolDetailView',
    data() {
        return {
            title: titles[this.$route.params.type].title || '隐私协议详情',
            html: titles[this.$route.params.type].html || '隐私协议详情',
        };
    },
};
</script>
<style scoped></style>